import axios from 'axios'

import environment from '../../variables/variables'

const register = (cancelToken, email, password, registration_code) => {
  return axios({
    url: environment === "production"
          ? "https://3dmss-api.bscs.org" : "http://127.0.0.1:8000",
    method: "post",
    cancelToken: cancelToken.token,
    withCredentials: true,
    data: {
      //Not doing "${...}" because of null values.  Set this in state.
      query: `
        mutation {
          register(
            email: "${email}"
            password: "${password}"
            registrationCode: "${registration_code}"
          ) {
            user {
              id
              email
            }
          }
        }
        `
    }
  })
  .then(response => {
    return response
  })
  .catch(error => {
    axios.isCancel(error) ? console.log(`Request canceled: ${error}`) : console.log(error)
  })
}

export default register
